'use client';

import { c as _c } from "react/compiler-runtime";
import * as SubframeCore from '@subframe/core';
import { FeatherCheck, FeatherChevronsUpDown, FeatherClipboard, FeatherGitBranch, FeatherShield } from '@subframe/core';
import React from 'react';
export type AdminRole = 'DESENVOLVEDOR' | 'SECRETARIA' | 'ADMIN_PLATAFORMA';
interface AdminRoleMeta {
  value: AdminRole;
  label: string;
  description: string;
  icon: React.ReactNode;
}
export const ADMIN_ROLES: AdminRoleMeta[] = [{
  value: 'ADMIN_PLATAFORMA',
  label: 'Administrador da plataforma',
  description: 'Operação, financeiro e plataforma',
  icon: <FeatherShield className="h-4 w-4" />
}, {
  value: 'SECRETARIA',
  label: 'Secretaria',
  description: 'Secretaria e atendimento',
  icon: <FeatherClipboard className="h-4 w-4" />
}, {
  value: 'DESENVOLVEDOR',
  label: 'Desenvolvedor',
  description: 'Operações, flows e plataforma',
  icon: <FeatherGitBranch className="h-4 w-4" />
}];
const getRoleMeta = (role: AdminRole): AdminRoleMeta => ADMIN_ROLES.find(item => item.value === role) ?? ADMIN_ROLES[0];
interface AdminRoleSwitcherProps {
  selected: AdminRole;
  onSelect: (role: AdminRole) => void;
  isCollapsed?: boolean;
  className?: string;
}
export const AdminRoleSwitcher: React.FC<AdminRoleSwitcherProps> = t0 => {
  const $ = _c(25);
  const {
    selected,
    onSelect,
    isCollapsed: t1,
    className
  } = t0;
  const isCollapsed = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== selected) {
    t2 = getRoleMeta(selected);
    $[0] = selected;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const current = t2;
  const t3 = `w-full ${className || ""}`;
  let t4;
  if ($[2] !== t3) {
    t4 = t3.trim();
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `group flex w-full items-center gap-3 rounded-md border border-solid transition-all focus-visible:ring-0 focus-visible:outline-none ${isCollapsed ? "justify-center border-transparent p-2 hover:bg-neutral-100" : "bg-default-background border-neutral-200 px-3 py-2.5 hover:bg-neutral-50"}`;
  let t6;
  if ($[4] !== current.icon) {
    t6 = <span className="bg-brand-100 text-brand-700 flex h-7 w-7 flex-none items-center justify-center rounded">{current.icon}</span>;
    $[4] = current.icon;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== current.label || $[7] !== isCollapsed) {
    t7 = !isCollapsed && <><div className="flex min-w-0 flex-1 flex-col items-start gap-0.5"><span className="text-caption-bold font-caption-bold text-default-font w-full min-w-0 truncate text-left">{current.label}</span><span className="text-subtext-color text-[10px] font-medium tracking-wide uppercase">Papel</span></div><FeatherChevronsUpDown className="h-4 w-4 flex-none text-neutral-400" /></>;
    $[6] = current.label;
    $[7] = isCollapsed;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6 || $[11] !== t7) {
    t8 = <SubframeCore.DropdownMenu.Trigger asChild={true}><button type="button" aria-label="Alternar papel" className={t5}>{t6}{t7}</button></SubframeCore.DropdownMenu.Trigger>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex w-full flex-col items-start gap-1 border-b border-solid border-neutral-100 px-4 py-3"><span className="text-caption-bold font-caption-bold text-default-font">Alternar papel</span><span className="text-subtext-color text-body-xs">Define quais áreas ficam visíveis no menu</span></div>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== onSelect || $[15] !== selected) {
    t10 = ADMIN_ROLES.map(item => {
      const isSelected = item.value === selected;
      return <SubframeCore.DropdownMenu.Item key={item.value} asChild={true} onSelect={() => onSelect(item.value)}><div className={`flex w-full items-center gap-3 border-l-4 px-4 py-2.5 transition-colors ${isSelected ? "bg-brand-50 border-brand-600" : "border-transparent hover:bg-neutral-50"}`}><span className={`flex h-8 w-8 flex-none items-center justify-center rounded ${isSelected ? "bg-brand-100 text-brand-700" : "bg-neutral-100 text-neutral-600"}`}>{item.icon}</span><div className="flex min-w-0 flex-1 flex-col items-start gap-0.5"><span className="text-caption-bold font-caption-bold text-default-font truncate">{item.label}</span><span className="text-subtext-color text-body-xs truncate">{item.description}</span></div>{isSelected && <FeatherCheck className="text-brand-600 h-4 w-4 flex-none" />}</div></SubframeCore.DropdownMenu.Item>;
    });
    $[14] = onSelect;
    $[15] = selected;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content side="bottom" align="start" sideOffset={4} asChild={true}><div className="z-[1000] flex w-72 flex-col items-start rounded-md border border-solid border-neutral-200 bg-white shadow-lg">{t9}<div className="flex w-full flex-col items-start">{t10}</div></div></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t8) {
    t12 = <SubframeCore.DropdownMenu.Root>{t8}{t11}</SubframeCore.DropdownMenu.Root>;
    $[19] = t11;
    $[20] = t8;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t4) {
    t13 = <div className={t4}>{t12}</div>;
    $[22] = t12;
    $[23] = t4;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};